"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BlockingInputComponent: ()=>BlockingInputComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_TravelBotChatSingleDialogGeneric_js_namespaceObject = require("./TravelBotChatSingleDialogGeneric.js");
let count = 0;
const BlockingInputComponent = /*#__PURE__*/ external_react_default().memo((props)=>{
    const { setIsDisablingInputValue } = props;
    const shouldBlockInput = 5 === count;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (shouldBlockInput) {
            setIsDisablingInputValue(true);
            setTimeout(()=>{
                setIsDisablingInputValue(false);
            }, 30000);
        } else count++;
    }, []);
    return shouldBlockInput ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotChatSingleDialogGeneric_js_namespaceObject.TravelBotChatSingleDialogGeneric, {
        message: {
            role: 'assistant',
            content: 'Sorry, service will be disabled for 30s.'
        }
    }) : null;
});
exports.BlockingInputComponent = __webpack_exports__.BlockingInputComponent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BlockingInputComponent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
